import { captureEvent } from '@sentry/react';
import { useEffect, useRef } from 'react';
import { PerformanceLoadingThresholds } from '../common/constants';

export function useComponentLoadTime(isLoading: boolean, componentName: string, extraParams: any) {
    const startTimeRef = useRef<number | null>(null);
    
    useEffect(() => {
        if (isLoading && startTimeRef.current === null) {
            startTimeRef.current = performance.now();
        } else if (!isLoading && startTimeRef.current !== null) {
            const duration = performance.now() - startTimeRef.current;
            if (duration > PerformanceLoadingThresholds.SLOW_LOAD_MS) {
                const isManualEvent = true;
                captureEvent({
                    message: `Slow component load: ${componentName}`,
                    level: 'warning',
                    tags: {
                        component: componentName,
                        duration: Math.round(duration),
                    },
                    extra: {
                        componentName,
                        duration: Math.round(duration),
                        durationSeconds: (duration / 1000).toFixed(2),
                        timestamp: new Date().toISOString(),
                        isManualEvent,
                        ...extraParams,
                    },
                });
            }
            
            startTimeRef.current = null;
        }
    }, [isLoading, componentName]);
}